import actions from './actions'

export default function ContractEmailListsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        saveSuccess: false,
      }
    case actions.LIST_CONTRACTEMAILLIST:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_CONTRACTEMAILLIST:
      console.log('ContractEmailListsReducer EDIT_CONTRACTEMAILLIST', action.result)
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CONTRACTEMAILLIST:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_CONTRACTEMAILLIST:
      console.log('ContractEmailListsReducer NEW_CONTRACTEMAILLIST', action)
      return {
        ...state,
        editing: { contractEmailListID: 0, contractID: action.contractID },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_CONTRACTEMAILLIST_RECIEVED ||
      actions.UPDATE_CONTRACTEMAILLIST_RECIEVED ||
      actions.DELETE_CONTRACTEMAILLIST_RECIEVED:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
